import {Fragment} from 'react'

import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'

const SingleSignOnIntro = props => (
  <Fragment>
    <Stack component='div' sx={{flexDirection: {xs: 'column', md: 'row'}, gap: 2, justifyContent: 'space-between'}}>
      <Stack component='div'>
        <Typography variant='h4' gutterBottom>Setting up Authentication</Typography>
        <Typography variant='body1'>with <Typography color='success' variant='span'>{props.client.name}</Typography></Typography>
      </Stack>
      <Stack>
        <Typography variant='h5' gutterBottom>Here's what that means</Typography>
        <Divider />
        <Typography variant='body1' gutterBottom>
          Your credentials can be used for authentication on {props.client.name}.
        </Typography>
        <Divider />
        <Typography variant='body1' gutterBottom>
          {props.client.name} can request your Account information (<Typography color='info' variant='span'>Email, First Name, e.t.c</Typography>) from Accounts.
        </Typography>
        <Divider />
        <Typography variant='body1' gutterBottom>
          {props.client.name} will be able to contact you via your email as necessary.
        </Typography>
      </Stack>
    </Stack>
    <ButtonGroup className='button-group' component='div' sx={{justifyContent: 'flex-end', width: '100%'}} spacing={2}>
      <Button onClick={props.accept}>Accept</Button>
      <Button onClick={props.decline} color='error' sx={{marginLeft: '10px'}}>Decline</Button>
    </ButtonGroup>
  </Fragment>
)

export default SingleSignOnIntro
